
    import { Component, Vue } from 'vue-property-decorator';
    import AppSwitch from '@/components/AppSwitch.vue';
    import {IBook} from "@/interfaces/book.interface";
    import BookName = IBook.BookName;
    import {IProfile} from "@/modules/Profile/interfaces/profile.interface";
    import PhoneInput from "@/components/PhoneInput.vue";
    import ThemeSwitcher from "@/components/ThemeSwitcher.vue";
    import * as emailValidator from 'email-validator';
    import {ICorp} from "@/modules/Corps/interfaces/corp.interface";
    import _ from "lodash";
    import {IApp} from "@/interfaces/app.interface";
    import moment from "moment";
    import {IAppState} from "@/interfaces/app-state.interface";
    import {IAuth} from "@/modules/Auth/interfaces/auth.interface";

    @Component({
      components: {
        AppSwitch,
        PhoneInput,
        ThemeSwitcher,
      }
    })
    export default class ProfileForm extends Vue {
      $refs: any;
      lastUpdate = '';
      browserInfo = '';

      get formRulesContacts() {
        return {
          surName: [{required: true, message: 'Заполните поле', trigger: 'blur'}],
          firstName: [{required: true, message: 'Заполните поле', trigger: 'blur'}],
          middleName: [{required: false, message: 'Заполните поле', trigger: 'blur'}],
          phone: [{
            validator: (rule, value, callback) => this.formModel.email || !!value ? callback() : callback(new Error('Заполните поле')),
            required: true,
            message: 'Заполните поле',
            trigger: 'blur'
          }],
          email: [{
            validator: (rule, value, callback) => this.formModel.phone || emailValidator.validate(value) ? callback() : callback(new Error('Укажите email')),
            message: 'Укажите email',
            trigger: 'blur'
          }]
        };
      }

      get formFields() {
        let fields: any[] = [
          { twoColumns: false, subFields: [{ prop: 'contact', placeholder: 'Аккаунт', disabled: true, hide: this.refMode, },] },
          { twoColumns: false, subFields: [{ prop: 'surName', placeholder: 'Фамилия', },] },
          { twoColumns: false, subFields: [{ prop: 'firstName', placeholder: 'Имя', },] },
          { twoColumns: false, subFields: [{ prop: 'middleName', placeholder: 'Отчество', hide: this.refMode, },] },
          { customTemplate: true, templateName: 'emailPhone', twoColumns: true, },
          {
            twoColumns: false,
            subFields: [
              {
                prop: 'corpName',
                placeholder: 'Корпорация',
                disabled: true,
                hide: this.refMode,
                withBtn: this.userAccess.reLoginFlag,
                btnProps: {
                  type: 'primary',
                  text: 'Переключиться',
                  action: this.openSelectCorpPopup,
                },
              },
            ]
          },
        ];

        if (this.refMode) {
          fields.push({ twoColumns: false, subFields: [{ prop: 'password', placeholder: 'Пароль', },] },);
        }

        if (this.formModel.company) {
          fields.push(...[
            { twoColumns: false, subFields: [{ prop: 'company', placeholder: 'Юридическое наименование', disabled: true, },],},
            { twoColumns: true,
              subFields: [
                { prop: 'inn', placeholder: 'ИНН', disabled: true, },
                { prop: 'bankAccount', placeholder: 'Расчетный счет', disabled: true, },
              ]
            },
            { twoColumns: true,
              subFields: [
                { prop: 'bic', placeholder: 'БИК', disabled: true, },
                { prop: 'bankName', placeholder: 'Наименование банка', disabled: true, },
              ]
            },
          ]);
        }

        return fields;
      }

      get storeState(): IAppState { return this.$store.state; }
      get userAccess(): IAuth.UserAccess { return this.storeState.auth.userAccess; }
      get formModel(): IProfile.DataProfile { return this.storeState.profile.profileData; }
      get refMode() { return this.storeState.profile.refMode; }
      get defaultForm(): IProfile.IChangeableData { return this.storeState.profile.defaultForm; }
      get hasChanges() { return this.$store.getters['profile/hasProfileChanges']; }

      get phone() { return this.formModel.phone; }
      set phone(val) { this.$store.commit('profile/setProfileDataProperty', { name: 'phone', value: val }); }

      get parkChoice() { return this.formModel.parkChoice }
      set parkChoice(val) { this.$store.commit('profile/setProfileDataProperty', { name: 'parkChoice', value: val }); }

      // Values for selects.
      get parkValues() { return this.storeState.book.books[BookName.parksMyAll]; }

      created() {
        this.setDefaultForm();
        this.checkRefMode();

        let storageDate = localStorage.getItem(IApp.LocalStorageKeys.LastAppUpdateDate);
        if (storageDate) {
          this.lastUpdate = moment(storageDate).format(IApp.DateFormats.PrintedDateTime);
        }

        const ua = navigator.userAgent;
        let browser, version;

        if (ua.includes("Firefox/")) {
          browser = "Firefox";
          version = ua.split("Firefox/")[1];
        } else if (ua.includes("Edg/")) {
          browser = "Edge";
          version = ua.split("Edg/")[1];
        } else if (ua.includes("Chrome/")) {
          browser = "Chrome";
          version = ua.split("Chrome/")[1].split(" ")[0];
        } else if (ua.includes("Safari/")) {
          browser = "Safari";
          version = ua.split("Version/")[1].split(" ")[0];
        }
        this.browserInfo = `Открыто в ${browser} v.${version}`;
      }

      reloadPage() {
        document.location.reload()
      }

      inputValue(value, prop) {
        this.$store.commit('profile/setProfileDataProperty', { name: prop, value });
      }

      async onChangePassword() {
        await this.$store.dispatch('dialog/openDialog', { blockName: 'profile', dialogName: 'changePasswordPopup' });
      }

      async onChangeEmail() {
        await this.$store.dispatch('dialog/openDialog', { blockName: 'profile', dialogName: 'changeEmailPopup' });
      }

      saveChanges() {
        this.$refs.profileForm.validate(async (valid) => {
          if (valid) {
            let data = await this.$store.dispatch('profile/saveChanges');

            if (data.success) {
              this.setDefaultForm();

              if (this.refMode) {
                this.clearRefMode();
                await this.$store.dispatch('openPage', {routeName: IApp.ROUTE_NAME.HOME});
              }
            }
          }
          else {
            return false;
          }
        });
      }

      setDefaultForm(revert = false) {
        if (revert) {
          this.$refs.profileForm.clearValidate();
        }
        Object.keys(this.defaultForm).forEach(key => {
          if (revert) this.$store.commit('profile/updateProfileProp', { name: key, value: this.defaultForm[key] });
          else this.$store.commit('profile/updateDefaultFormProp', { name: key, value: this.formModel[key] })
        });
      }

      checkRefMode() {
        const refCode = this.$route.query[ICorp.UrlGetParams.RefLink];
        if (refCode && refCode !== '') {
          this.$store.commit('profile/setProperty', { name: 'refMode', value: true });
          this.$store.commit('profile/setProperty', { name: 'refCode', value: refCode });

          const clearProp = ['surName', 'firstName', 'middleName',];
          clearProp.forEach(prop => {
            this.$store.commit('profile/updateProfileProp', { name: prop, value: '' });
            this.$store.commit('profile/updateDefaultFormProp', { name: prop, value: '' });
          });

          Vue.set(this.formRulesContacts, 'password', [{required: true, message: 'Заполните поле', trigger: 'blur'}]);

          localStorage.setItem(ICorp.StorageKeys.NeedRegByRef, JSON.stringify(true));
          localStorage.setItem(ICorp.StorageKeys.URLRegByRef, JSON.stringify(window.location.href));
        }
      }

      clearRefMode() {
        const refCode = this.$route.query[ICorp.UrlGetParams.RefLink];
        if (refCode && refCode !== '') {
          this.$store.commit('profile/setProperty', { name: 'refMode', value: false });
          this.$store.commit('profile/setProperty', { name: 'refCode', value: '' });
          const query = _.clone(this.$route.query);
          delete query[ICorp.UrlGetParams.RefLink];
          this.$router.replace({query});

          localStorage.setItem(ICorp.StorageKeys.NeedRegByRef, JSON.stringify(false));
          localStorage.setItem(ICorp.StorageKeys.URLRegByRef, '');
        }
      }

      async goToAuth() {
        await this.$store.dispatch('openPage', {routeName: IApp.ROUTE_NAME.PAGE_AUTHORIZATION});
      }

      async openSelectCorpPopup() {
        await this.$store.dispatch('profile/openSelectCorpPopup');
      }

      async changeTabAction() {
        if (this.hasChanges) await this.saveChanges();
      }
    }
